// tslint:disable:object-literal-sort-keys

export const TABS_VIDEOS: { [key: string]: { video: string; videoStartSecond?: number } } = {
  yardPark: {
    video: 'srM6quTmtDs',
  },
  decoration: {
    video: 'HOc1T14vtaQ',
    videoStartSecond: 9,
  },
  facades: {
    video: 'D2XJ8xrsJRY',
  },
  elevators: {
    video: 'MoRMJjcK86I',
  },
  entrances: {
    video: 'KeddbrZbgGM',
  },
  sockets: {
    video: 'NFK85qHvDY4',
  },
  lobby: {
    video: 'iGPnsjCNLi8',
  },
  steps: {
    video: 'CA4jtQKnR_0',
  },
  howItsDone: {
    video: '4JpqzCEdW_s',
  },
  playability: {
    video: 'STkHnKXwWJ0',
  },
};
